import React from 'react';
import customHeaders, { getSpace } from '../../common/headers';
import { useState, useEffect } from 'react';
import { useRef } from 'react';
import { TableBox, ButtonBasic } from '@lk-gtcom/ecomlab-components';
import { useDataTable } from '../../common/hooks';
import { TitlePage } from '../../components/TitlePage/TitlePage';
import useGeneralStore from '../../store/general';
import { ModalCreateAutocompleteTemplatesAi } from './Modal/ModalCreateAutocompleteTemplatesAi';
import { usePushNotifications } from '../../common/pushNotification';
import { useResponseHandler } from '../../common/auth';

const AutocompleteTemplatesAi = ({ }) => {
    const selectedSpace = useGeneralStore((state) => state.selectedSpace);
    const headers = { ...customHeaders, ...getSpace(selectedSpace) };
    const { handleStatusCode, handleTableResponse, handleRequestError } = useResponseHandler();
    // Обработка ошибок
    const { addErrorPush, addSuccessPush } = usePushNotifications();

    // Таблица
    const paginatorRef = useRef();
    const [setTable, tableProps, setTableFuncs] = useDataTable(
        paginatorRef.current?.setTotal,
        paginatorRef
    );
    const { setLoading, setFetchedData, setHeaders, setSort } = setTableFuncs;
    const { total, loading } = tableProps;

    // Modal
    const [isModal, setIsModal] = useState(false)
    const [currentСampaign, setCurrentСampaign] = useState(null)

    const contextMenuArr = [
        {
            label: 'Удалить',
            onClick: (e) => {
                const authorTask = e?.['Автор']?.[2]
                const client_id = localStorage.getItem('client_id');
                if (authorTask == client_id) {
                    fetchDeleteTask(e?.['Id задачи'])
                } else {
                    addErrorPush('Задачу может удалить только ее автор')
                }
            }
        },
    ];

    // Таблица
    const fetchTableData = (params) => {
        setLoading(true);

        let sort, filtersParam;
        if (params) {
            [sort, filtersParam] = params;
        }

        const url = `https://apps0.ecomru.ru:4460/api/v1/task/table${sort?.length > 0
            ? '?order_param=' + sort[0] + '&order_direction=' + sort[1]
            : ''
            }`;

        const body = JSON.stringify({
            filters: filtersParam,
            page: paginatorRef.current.page,
            limit: paginatorRef.current.limit
        });

        fetch(url, { method: 'POST', headers, body })
            .then(handleTableResponse)
            .then((json) => setTable(json))
            .catch(handleRequestError)
            .finally(() => setLoading(false));
    };

    // Удаление задачи
    const fetchDeleteTask = (id) => {
        let url = `https://apps0.ecomru.ru:4460/api/v1/task/delete/${id}`

        fetch(url, { method: 'DELETE', headers })
            .then(handleTableResponse)
            .then((json) => setTimeout(() => fetchTableData(), 1000))
            .catch(handleRequestError);
    }

    // Прроверить статус задачи
    const fetchGetStatusTask = (id) => {
        let url = `https://apps0.ecomru.ru:4460/api/v1/task/status?task_id=${id}`

        fetch(url, { method: 'GET', headers })
            .then(handleTableResponse)
            .then((json) => addSuccessPush(`Статус задачи: ${JSON.stringify(json)}`))
            .catch(handleRequestError);
    }

    useEffect(() => {
        if (!isModal) {
            fetchTableData()
        }
    }, [isModal]);

    const onActionHandler = (e) => {
        const uid = e?.['Id задачи']
        fetchGetStatusTask(uid)
    }

    return (
        <>
            {isModal && <ModalCreateAutocompleteTemplatesAi
                setIsModal={(e) => setIsModal(e)}
                currentСampaign={currentСampaign}
                setCurrentСampaign={setCurrentСampaign}
                fetchDeleteTask={fetchDeleteTask}
            />}

            <div className='create-campaign-from-rules'>
                <TitlePage
                    title='Автозаполнение шаблонов'
                />

                <TableBox
                    {...tableProps}
                    fetchCallback={(e) => fetchTableData(e)}
                    ref={paginatorRef}
                    paginator={true}
                    child={
                        <>
                            <ButtonBasic
                                onClick={(e) => setIsModal(true)}
                                green
                                text='Cоздать задачу'
                                size='32px'
                            />

                            <ButtonBasic
                                onClick={(e) => fetchTableData()}
                                blue
                                text='Обновить статусы'
                                size='32px'
                            />
                        </>
                    }
                    onAction={onActionHandler}
                    contextMenuArr={contextMenuArr}
                />
            </div>
        </>
    )
}

export { AutocompleteTemplatesAi }